import { flatten } from "../../../../utils/array.helper"

export const fetchConceptualLabelsSelectors = {
    all: result => result?.data || [],
    byId: (arg, result) => {
        // const conceptualLabelResult = {
        //     ...result,
        //     data: result?.data?.find(item => item.id === arg.id),
        // }
        // return conceptualLabelResult
        
        //flatten the data
        const flattenedData = flatten(result?.data)
        return {
            ...result,
            data: flattenedData.find(item => item.id === arg.id),
        }
    },
}
